import React, { useState, useRef } from "react";
import axios from "axios";
import { useUser } from "../context/useUser";

const url = process.env.REACT_APP_BACKEND_CONNECTION;

export default function AdminImportFloorPlans() {
  const { user } = useUser();
  const [file, setFile] = useState(null);
  const [imageFiles, setImageFiles] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const imageInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setStatus("Please select a CSV file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    imageFiles.forEach((imageFile) => {
      formData.append("images", imageFile);
    });

    setLoading(true);
    setStatus("");

    try {
      const response = await axios.post(
        `${url}/admin/housing-company/import-floor-plans`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      let message = response.data.message || "Import completed.";

      if (response.data.uploadedImages?.length > 0) {
        message += `\nUploaded images: ${response.data.uploadedImages.join(", ")}`;
      }

      if (response.data.created?.length > 0) {
        message += `\nCreated floor plans: ${response.data.created
          .map((c) => `${c.housing_company} / ${c.floor_plan_name}`)
          .join(", ")}`;
      }

      if (response.data.skipped?.length > 0) {
        message += `\nSkipped existing: ${response.data.skipped
          .map((c) => `${c.housing_company} / ${c.floor_plan_name}`)
          .join(", ")}`;
      }

      if (response.data.errors?.length > 0) {
        message += `\nErrors:\n${response.data.errors
          .map((e) => `${e.error} — ${JSON.stringify(e.row)}`)
          .join("\n")}`;
      }

      setStatus(message);
    } catch (error) {
      console.error("Import error:", error);
      setStatus(
        error.response?.data?.error || "Something went wrong during import."
      );
    } finally {
      setLoading(false);
      setFile(null);
      setImageFiles([]);
      if (fileInputRef.current) fileInputRef.current.value = "";
      if (imageInputRef.current) imageInputRef.current.value = "";
    }
  };

  return (
    <div className="default-container">
      <div className="default-box">
        <h2 className="default-title">
          <i className="fas fa-layer-group" /> Lisää Pohjapiirrokset
        </h2>

        <form onSubmit={handleSubmit} className="admin-form">
          <label className="admin-label">
            <i className="fas fa-file-csv" /> Valitse CSV Tiedosto:
          </label>

          <input
            ref={fileInputRef}
            type="file"
            accept=".csv"
            onChange={(e) => setFile(e.target.files[0])}
            className="admin-input"
          />

          <label className="admin-label">
            <i className="fas fa-images" /> Valitse kuvatiedostot:
          </label>

          <input
            ref={imageInputRef}
            type="file"
            accept="image/*"
            multiple
            onChange={(e) => setImageFiles(Array.from(e.target.files || []))}
            className="admin-input"
          />

          <p className="default-text">
            CSV:n image-sarakkeen arvon tulee vastata ladatun tiedoston nimeä.
          </p>

          <button className="default-button" type="submit" disabled={loading}>
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin" /> Ladataan...
              </>
            ) : (
              <>
                <i className="fas fa-upload" /> Lataa
              </>
            )}
          </button>
        </form>

        {status && (
          <pre
            className={`status-text ${
              status.toLowerCase().includes("error") ||
              status.toLowerCase().includes("wrong") ||
              status.toLowerCase().includes("please")
                ? "error"
                : "success"
            }`}
            style={{ whiteSpace: "pre-wrap", textAlign: "left" }}
          >
            {status}
          </pre>
        )}
      </div>
    </div>
  );
}
